import {chain} from "@Common/utils/fs";

import {groupItemEditors} from "./minors/group-item-editors";

export const getItemEditor = (modules) => chain(
    groupItemEditors(modules.itemEditors),
    (_) => ({
        ..._,
        prepareSave: (item) => chain(item,
            modules.cleanItem,
            (newItem) => _.prepareSave(newItem),
        ),
    }),
);
